var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

// src/dispatchEvent.ts
var PEXIP_ENGAGE_PLUGIN_EVENT = "SkedifyPluginEvent";
function dispatchEvent({
  subtype,
  target,
  type,
  ...eventInitDict
}) {
  const event = new CustomEvent(PEXIP_ENGAGE_PLUGIN_EVENT, {
    ...eventInitDict,
    detail: { ...eventInitDict.detail, type, subtype }
  });
  return target.dispatchEvent(event);
}

// src/PluginInstance.ts
import {
  createSearchParamConfig,
  encodeConfigAsHash,
  encodeURIParameters,
  parsePluginConfiguration
} from "@pexip-engage-public/plugin-configuration-parser";
import {
  PluginError,
  PluginEvent,
  PluginMisconfigured,
  RequestEvent
} from "@pexip-engage-public/plugin-events";
import { logger } from "@pexip-engage-public/plugin-utils";
import resizer from "iframe-resizer/js/iframeResizer.min.js";

// src/PexipEngagePluginFrame.ts
var SPINNER_STYLE = `<style>@keyframes spin{to{transform: rotate(360deg);}}.container{display: flex; align-items: center; justify-content: center; height: calc(700px - 1rem);}svg{fill: rgb(10 33 54); color: rgb(229 231 235); animation: spin 1s linear infinite;}</style>`;
var SPINNER_DOM = `<div class="container"><svg aria-hidden="true" fill="none" viewBox="0 0 100 101" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg"> <path fill="currentColor" d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" ></path> <path fill="currentFill" d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"></path></svg></div>`;
var spinnerHtml = `<!DOCTYPE html><html><head>${SPINNER_STYLE}</head><body>${SPINNER_DOM}</body></html>`;
var spinnerTemplate = document.createElement("template");
spinnerTemplate.innerHTML = `${SPINNER_STYLE}${SPINNER_DOM}`;
var _shadowRoot;
var PexipEngagePluginFrame = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _shadowRoot, void 0);
    __privateSet(this, _shadowRoot, this.attachShadow({ mode: "open" }));
    __privateGet(this, _shadowRoot).appendChild(spinnerTemplate.content.cloneNode(true));
  }
  createPexipPlugin(src) {
    const iframe = document.createElement("iframe");
    iframe.src = src;
    iframe.style.border = "0px";
    iframe.style.overflow = "hidden";
    iframe.style.height = "707px";
    iframe.style.width = "100%";
    iframe.height = "100%";
    iframe.width = "100%";
    iframe.title = "Pexip Engage Plugin";
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    iframe.allow = "clipboard-write";
    iframe.onload = () => iframe.removeAttribute("srcdoc");
    iframe.srcdoc = spinnerHtml;
    __privateGet(this, _shadowRoot).innerHTML = "";
    __privateGet(this, _shadowRoot).appendChild(iframe);
    return iframe;
  }
};
_shadowRoot = new WeakMap();
var FRAME_IDENTIFIER = "pexip-engage-plugin-frame";
function getPexipEngagePluginFrame() {
  if (!window.customElements.get(FRAME_IDENTIFIER)) {
    window.customElements.define(FRAME_IDENTIFIER, PexipEngagePluginFrame);
  }
  return window.customElements.get(FRAME_IDENTIFIER);
}

// src/PluginInstance.ts
var PexipEngagePluginFrame2 = getPexipEngagePluginFrame();
var _instance, _target, _state, _meta, _status, _fallbackTimeoutId, _fallbackHTML, _config, _handleMessage, _hooks, _listeners, _url, _instances;
var _PluginInstance = class _PluginInstance {
  constructor(element, options = {}) {
    __privateAdd(this, _instance, void 0);
    __privateAdd(this, _target, void 0);
    __privateAdd(this, _state, null);
    __privateAdd(this, _meta, {});
    __privateAdd(this, _status, "pending");
    __privateAdd(this, _fallbackTimeoutId, null);
    __privateAdd(this, _fallbackHTML, void 0);
    __privateAdd(this, _config, void 0);
    __privateAdd(this, _handleMessage, async ({ message }) => {
      if (message.type === "STATE_UPDATE") {
        __privateSet(this, _state, message.payload);
        return;
      }
      const self = this;
      if (message.type === PluginEvent.STEP_SHOWN) {
        return dispatchEvent({
          target: __privateGet(this, _target),
          type: PluginEvent.STEP_SHOWN,
          detail: { instance: self, payload: message.payload }
        });
      }
      if (message.type === PluginEvent.ERROR) {
        return dispatchEvent({
          target: __privateGet(this, _target),
          type: PluginEvent.ERROR,
          subtype: message.payload,
          detail: { instance: self }
        });
      }
      if (isAppointmentEvent(message)) {
        return dispatchEvent({
          target: __privateGet(this, _target),
          type: message.type,
          detail: { instance: self }
        });
      }
      if (isInvalidEntityEvent(message)) {
        return dispatchEvent({
          target: __privateGet(this, _target),
          type: PluginEvent.MISCONFIGURED,
          subtype: message.type,
          detail: { instance: self }
        });
      }
      if (message.type === RequestEvent.PRE_APPOINTMENT_REQUEST) {
        let _message = message;
        __privateGet(this, _hooks).beforeAppointmentCreate?.({
          data: _message.payload,
          appointment: { meta: this.appointment.meta }
        });
        __privateGet(this, _instance).iFrameResizer.sendMessage({
          type: RequestEvent.PRE_APPOINTMENT_REQUEST,
          payload: { meta: __privateGet(this, _meta) }
        });
        return;
      }
      if (message.type === RequestEvent.REQUEST_ORIGIN_URL) {
        __privateGet(this, _instance).iFrameResizer.sendMessage({
          type: RequestEvent.REQUEST_ORIGIN_URL,
          payload: { href: window.location.href }
        });
        return;
      }
      if (message.type === RequestEvent.REQUEST_GEOLOCATION) {
        const geolocation = new Promise((res, rej) => {
          if (navigator && "geolocation" in navigator) {
            return navigator.geolocation.getCurrentPosition((result) => {
              res({
                timestamp: result.timestamp,
                coords: {
                  latitude: result.coords.latitude,
                  longitude: result.coords.longitude,
                  accuracy: result.coords.accuracy,
                  altitude: result.coords.altitude,
                  altitudeAccuracy: result.coords.altitudeAccuracy,
                  heading: result.coords.heading,
                  speed: result.coords.speed
                }
              });
            }, rej);
          }
          rej("User location not Available");
        });
        __privateGet(this, _instance).iFrameResizer.sendMessage({
          type: RequestEvent.REQUEST_GEOLOCATION,
          payload: await geolocation.catch((error) => ({ error }))
        });
        return;
      }
      logger.debug("Unhandled event: ", message);
    });
    __privateAdd(this, _hooks, {});
    __publicField(this, "openDebugger", () => {
      const searchParams = new URLSearchParams();
      searchParams.append("mergedConfig", encodeURIParameters(__privateGet(this, _config).config));
      searchParams.append("domConfig", encodeURIParameters(__privateGet(this, _config).domConfig));
      searchParams.append("hashConfig", encodeURIParameters(__privateGet(this, _config).hashConfig));
      searchParams.append("jsConfig", encodeURIParameters(__privateGet(this, _config).jsConfig));
      const url = `${__privateGet(_PluginInstance, _url)}/configuration-checker?${searchParams}`;
      window.open(url, "plugin-debugger");
      return url;
    });
    /** Destroy the instance */
    __publicField(this, "dispose", () => {
      __privateSet(this, _status, "disposed");
      __privateGet(this, _listeners).forEach(
        (listener) => __privateGet(this, _target).removeEventListener(PEXIP_ENGAGE_PLUGIN_EVENT, listener)
      );
      __privateGet(this, _listeners).clear();
      if (typeof __privateGet(this, _fallbackTimeoutId) === "number") {
        window.clearTimeout(__privateGet(this, _fallbackTimeoutId));
      }
      __privateGet(this, _instance).iFrameResizer.close();
      const idx = __privateGet(_PluginInstance, _instances).indexOf(this);
      __privateGet(_PluginInstance, _instances).splice(idx, 1);
    });
    // KEEP STABLE UNTIL February 2024
    /** @private internal API */
    __publicField(this, "setCSSVariable", (name, value) => {
      warnPrivate({ type: "function", name: "setCSSVariable" });
      __privateGet(this, _instance).iFrameResizer.sendMessage({
        type: RequestEvent.CSS_VAR_UPDATE,
        payload: { name, value }
      });
    });
    __publicField(this, "setCustomCSS", (css) => {
      __privateGet(this, _instance).iFrameResizer.sendMessage({
        type: RequestEvent.CUSTOM_CSS_UPDATE,
        payload: { css }
      });
    });
    __privateAdd(this, _listeners, /* @__PURE__ */ new Set());
    /** Add an event listener */
    __publicField(this, "addEventListener", (typeOrListener, cb) => {
      const type = isFunction(typeOrListener) ? void 0 : typeOrListener;
      const listener = isFunction(typeOrListener) ? typeOrListener : cb;
      if (!isFunction(listener))
        return;
      function internalListener(event) {
        if (!isCustomEvent(event))
          return true;
        if (type === void 0 || event.detail?.type === type)
          return listener?.(event);
      }
      __privateGet(this, _listeners).add(internalListener);
      __privateGet(this, _target).addEventListener(PEXIP_ENGAGE_PLUGIN_EVENT, internalListener);
    });
    __publicField(this, "EVENT_APPOINTMENT_CANCELLED", _PluginInstance.EVENT_APPOINTMENT_CANCELLED);
    __publicField(this, "EVENT_APPOINTMENT_COMPLETED", _PluginInstance.EVENT_APPOINTMENT_COMPLETED);
    __publicField(this, "EVENT_APPOINTMENT_CREATED", _PluginInstance.EVENT_APPOINTMENT_CREATED);
    __publicField(this, "EVENT_INVITE_ACCEPTED", _PluginInstance.EVENT_INVITE_ACCEPTED);
    __publicField(this, "EVENT_APPOINTMENT_EDITED", _PluginInstance.EVENT_APPOINTMENT_EDITED);
    __publicField(this, "EVENT_CREATION", _PluginInstance.EVENT_CREATION);
    __publicField(this, "EVENT_ERROR", _PluginInstance.EVENT_ERROR);
    __publicField(this, "EVENT_INIT", _PluginInstance.EVENT_INIT);
    __publicField(this, "EVENT_LOADED", _PluginInstance.EVENT_LOADED);
    __publicField(this, "EVENT_MISCONFIGURED", _PluginInstance.EVENT_MISCONFIGURED);
    __publicField(this, "EVENT_STEP_SHOWN", _PluginInstance.EVENT_STEP_SHOWN);
    __publicField(this, "MISCONFIGURED_CLIENT_ID", _PluginInstance.MISCONFIGURED_CLIENT_ID);
    __publicField(this, "MISCONFIGURED_CONTACT_HINTS", _PluginInstance.MISCONFIGURED_CONTACT_HINTS);
    __publicField(this, "MISCONFIGURED_GEOLOCATION", _PluginInstance.MISCONFIGURED_GEOLOCATION);
    __publicField(this, "MISCONFIGURED_INTENT_WITHOUT_RESOURCE_CODE", _PluginInstance.MISCONFIGURED_INTENT_WITHOUT_RESOURCE_CODE);
    __publicField(this, "MISCONFIGURED_LISTING_ID", _PluginInstance.MISCONFIGURED_LISTING_ID);
    __publicField(this, "MISCONFIGURED_OFFICE_ID", _PluginInstance.MISCONFIGURED_OFFICE_ID);
    __publicField(this, "MISCONFIGURED_RESOURCE_CODE", _PluginInstance.MISCONFIGURED_RESOURCE_CODE);
    __publicField(this, "MISCONFIGURED_SUBJECT_ID", _PluginInstance.MISCONFIGURED_SUBJECT_ID);
    __publicField(this, "MISCONFIGURED_TIMEZONE", _PluginInstance.MISCONFIGURED_TIMEZONE);
    __publicField(this, "ERROR_API_DOWN", _PluginInstance.ERROR_API_DOWN);
    __publicField(this, "ERROR_RECAPTCHA_SCRIPT_LOAD", _PluginInstance.ERROR_RECAPTCHA_SCRIPT_LOAD);
    __publicField(this, "ERROR_SUB_DATE_INTERPOLATION", _PluginInstance.ERROR_SUB_DATE_INTERPOLATION);
    __publicField(this, "ERROR_TRANSLATION", _PluginInstance.ERROR_TRANSLATION);
    __publicField(this, "INTENT_CANCEL", _PluginInstance.INTENT_CANCEL);
    __publicField(this, "INTENT_EDIT", _PluginInstance.INTENT_EDIT);
    __publicField(this, "INTENT_INVITE", _PluginInstance.INTENT_INVITE);
    __publicField(this, "INTENT_RESCHEDULE", _PluginInstance.INTENT_RESCHEDULE);
    __publicField(this, "INTENT_COMPLETE", _PluginInstance.INTENT_COMPLETE);
    __publicField(this, "INTENT_SCHEDULE", _PluginInstance.INTENT_SCHEDULE);
    if (!isElement(element))
      throw new Error("Invalid target passed, expected an element.");
    if (!isValidConfiguration(options))
      throw new Error("Invalid configuration passed, expected an object.");
    const config = parsePluginConfiguration({
      element,
      options,
      hash: window.location.hash,
      href: window.location.href,
      browserTimeZone: new Intl.DateTimeFormat().resolvedOptions().timeZone
    });
    try {
      const meta = JSON.parse(config.config.metadata ?? "{}");
      __privateSet(this, _meta, meta);
    } catch (error) {
      logger.warn("Failed to parse metadata", { error, metadata: config.config.metadata });
    }
    __privateSet(this, _config, config);
    __privateSet(this, _target, element);
    const existingInstance = __privateGet(_PluginInstance, _instances).find((i) => __privateGet(i, _target) === element);
    __privateSet(this, _fallbackHTML, existingInstance ? "" : element.innerHTML);
    existingInstance?.dispose();
    const container = new PexipEngagePluginFrame2();
    element.innerHTML = "";
    element.appendChild(container);
    const searchParams = createSearchParamConfig({ config: config.config });
    const src = `${__privateGet(_PluginInstance, _url)}/plugin?${searchParams}`;
    const iframe = container.createPexipPlugin(src);
    const self = this;
    const [instance] = resizer(
      {
        log: false,
        checkOrigin: false,
        onMessage: __privateGet(this, _handleMessage),
        resizeFrom: "child",
        heightCalculationMethod: "taggedElement",
        onInit() {
          __privateSet(self, _status, "success");
          dispatchEvent({
            target: element,
            type: PluginEvent.LOADED,
            bubbles: true,
            cancelable: true,
            detail: { instance: self }
          });
        }
      },
      iframe
    );
    __privateSet(this, _instance, instance);
    __privateGet(_PluginInstance, _instances).push(this);
    queueMacroTask(() => {
      dispatchEvent({
        target: element,
        type: PluginEvent.CREATION,
        bubbles: true,
        cancelable: true,
        detail: { instance: self }
      });
    });
  }
  // KEEP STABLE UNTIL February 2024
  /** @private internal API */
  get config() {
    warnPrivate({ name: "config", type: "property" });
    return __privateGet(this, _config);
  }
  // TODO documentation!
  /** Configuration of this plugin instance */
  get configuration() {
    return __privateGet(this, _config).config;
  }
  // KEEP STABLE UNTIL February 2024
  /** @private internal API */
  get hashConfig() {
    warnPrivate({ name: "hashConfig", type: "property" });
    return encodeConfigAsHash(__privateGet(this, _config).config);
  }
  setHook(type, callback) {
    __privateGet(this, _hooks)[type] = callback;
  }
  /** The current intention */
  get intention() {
    return __privateGet(this, _state)?.config.intent;
  }
  get appointment() {
    return {
      id: __privateGet(this, _state)?.appointmentId,
      location: {
        id: __privateGet(this, _state)?.officeId
      },
      meeting_type: __privateGet(this, _state)?.meetingType,
      subject: {
        id: __privateGet(this, _state)?.subjectId,
        category_id: __privateGet(this, _state)?.subjectCategoryId
      },
      meta: {
        getAll: () => {
          return __privateGet(this, _meta);
        },
        get: (key, defaultValue) => {
          return __privateGet(this, _meta)[key] ?? defaultValue;
        },
        set: (key, value) => {
          __privateGet(this, _meta)[key] = value;
          return __privateGet(this, _meta);
        },
        remove: (key) => {
          delete __privateGet(this, _meta)[key];
        }
      }
    };
  }
  get customer() {
    return __privateGet(this, _state)?.customer;
  }
  static setCSSVariable(name, value) {
    return _PluginInstance.getInstance(0)?.setCSSVariable(name, value);
  }
  static get customer() {
    return _PluginInstance.getInstance(0)?.customer;
  }
  static get appointment() {
    return _PluginInstance.getInstance(0)?.appointment;
  }
  static get intention() {
    return _PluginInstance.getInstance(0)?.intention;
  }
  // KEEP STABLE UNTIL February 2024
  /** @private internal API */
  static get config() {
    return _PluginInstance.getInstance(0)?.config;
  }
  // KEEP STABLE UNTIL February 2024
  /** @private internal API */
  static get hashConfig() {
    return _PluginInstance.getInstance(0)?.hashConfig;
  }
  static openDebugger() {
    return _PluginInstance.getInstance(0)?.openDebugger();
  }
  // KEEP STABLE UNTIL February 2024
  /** @private internal API */
  static get url() {
    return __privateGet(_PluginInstance, _url);
  }
  static get count() {
    return __privateGet(_PluginInstance, _instances).length;
  }
};
_instance = new WeakMap();
_target = new WeakMap();
_state = new WeakMap();
_meta = new WeakMap();
_status = new WeakMap();
_fallbackTimeoutId = new WeakMap();
_fallbackHTML = new WeakMap();
_config = new WeakMap();
_handleMessage = new WeakMap();
_hooks = new WeakMap();
_listeners = new WeakMap();
_url = new WeakMap();
_instances = new WeakMap();
__publicField(_PluginInstance, "dispose", () => {
  return _PluginInstance.getInstance(0)?.dispose();
});
__publicField(_PluginInstance, "disposeAll", () => {
  __privateGet(_PluginInstance, _instances).forEach((instance) => instance.dispose());
});
__publicField(_PluginInstance, "addEventListener", (...args) => {
  return _PluginInstance.getInstance(0)?.addEventListener(...args);
});
__privateAdd(_PluginInstance, _url, void 0);
// KEEP STABLE UNTIL February 2024
/** @private internal API */
__publicField(_PluginInstance, "setEnterpriseUrl", (url) => {
  __privateSet(_PluginInstance, _url, url);
});
__privateAdd(_PluginInstance, _instances, []);
__publicField(_PluginInstance, "getInstance", (num) => {
  if (!isPositiveNumber(num))
    return void 0;
  return __privateGet(_PluginInstance, _instances)[num];
});
__publicField(_PluginInstance, "awaitFirstInstance", async () => {
  const instance = _PluginInstance.getInstance(0);
  if (instance)
    return instance;
  return new Promise((resolve, reject) => {
    function listener(event) {
      if (event instanceof CustomEvent) {
        if (event.detail.type === _PluginInstance.EVENT_CREATION) {
          document.removeEventListener(PEXIP_ENGAGE_PLUGIN_EVENT, listener);
          return resolve(event.detail.instance);
        } else if (event.detail.type === _PluginInstance.EVENT_MISCONFIGURED || event.detail.type === _PluginInstance.EVENT_ERROR) {
          document.removeEventListener(PEXIP_ENGAGE_PLUGIN_EVENT, listener);
          const errorMessage = typeof event.detail.subtype === "string" ? `${event.detail.type}: ${event.detail.subtype}` : event.detail.type;
          return reject(errorMessage);
        }
      }
    }
    document.addEventListener(PEXIP_ENGAGE_PLUGIN_EVENT, listener);
  });
});
/** @deprecated */
__publicField(_PluginInstance, "version", {
  value: "__PACKAGE_VERSION__"
});
/** @deprecated */
__publicField(_PluginInstance, "build", {
  value: "__PACKAGE_BUILD_HASH__"
});
__publicField(_PluginInstance, "EVENT_APPOINTMENT_CANCELLED", PluginEvent.APPOINTMENT_CANCELLED);
__publicField(_PluginInstance, "EVENT_APPOINTMENT_COMPLETED", PluginEvent.APPOINTMENT_COMPLETED);
__publicField(_PluginInstance, "EVENT_APPOINTMENT_CREATED", PluginEvent.APPOINTMENT_CREATED);
__publicField(_PluginInstance, "EVENT_INVITE_ACCEPTED", PluginEvent.INVITE_ACCEPTED);
__publicField(_PluginInstance, "EVENT_APPOINTMENT_EDITED", PluginEvent.APPOINTMENT_EDITED);
__publicField(_PluginInstance, "EVENT_CREATION", PluginEvent.CREATION);
__publicField(_PluginInstance, "EVENT_ERROR", PluginEvent.ERROR);
__publicField(_PluginInstance, "EVENT_INIT", PluginEvent.INIT);
__publicField(_PluginInstance, "EVENT_LOADED", PluginEvent.LOADED);
__publicField(_PluginInstance, "EVENT_MISCONFIGURED", PluginEvent.MISCONFIGURED);
__publicField(_PluginInstance, "EVENT_STEP_SHOWN", PluginEvent.STEP_SHOWN);
__publicField(_PluginInstance, "MISCONFIGURED_CLIENT_ID", PluginMisconfigured.CLIENT_ID);
__publicField(_PluginInstance, "MISCONFIGURED_CONTACT_HINTS", PluginMisconfigured.CONTACT_HINTS);
__publicField(_PluginInstance, "MISCONFIGURED_GEOLOCATION", PluginMisconfigured.GEOLOCATION);
__publicField(_PluginInstance, "MISCONFIGURED_INTENT_WITHOUT_RESOURCE_CODE", PluginMisconfigured.INTENT_WITHOUT_RESOURCE_CODE);
__publicField(_PluginInstance, "MISCONFIGURED_LISTING_ID", PluginMisconfigured.LISTING_ID);
__publicField(_PluginInstance, "MISCONFIGURED_OFFICE_ID", PluginMisconfigured.OFFICE_ID);
__publicField(_PluginInstance, "MISCONFIGURED_RESOURCE_CODE", PluginMisconfigured.RESOURCE_CODE);
__publicField(_PluginInstance, "MISCONFIGURED_SUBJECT_ID", PluginMisconfigured.SUBJECT_ID);
__publicField(_PluginInstance, "MISCONFIGURED_TIMEZONE", PluginMisconfigured.TIMEZONE);
__publicField(_PluginInstance, "ERROR_API_DOWN", PluginError.API_DOWN);
__publicField(_PluginInstance, "ERROR_RECAPTCHA_SCRIPT_LOAD", PluginError.RECAPTCHA_SCRIPT_LOAD);
__publicField(_PluginInstance, "ERROR_SUB_DATE_INTERPOLATION", PluginError.SUB_DATE_INTERPOLATION);
__publicField(_PluginInstance, "ERROR_TRANSLATION", PluginError.TRANSLATION);
__publicField(_PluginInstance, "INTENT_CANCEL", "cancel");
__publicField(_PluginInstance, "INTENT_EDIT", "edit");
__publicField(_PluginInstance, "INTENT_INVITE", "invite");
__publicField(_PluginInstance, "INTENT_RESCHEDULE", "reschedule");
__publicField(_PluginInstance, "INTENT_COMPLETE", "complete");
__publicField(_PluginInstance, "INTENT_SCHEDULE", "schedule");
var PluginInstance = _PluginInstance;
function isPositiveNumber(num) {
  return typeof num === "number" && num >= 0;
}
function isCustomEvent(event) {
  return event instanceof CustomEvent;
}
function isElement(element) {
  return element instanceof HTMLElement;
}
function isValidConfiguration(configuration) {
  return typeof configuration === "object" && configuration !== null;
}
function isFunction(fn) {
  return fn instanceof Function;
}
var APPOINTMENT_EVENTS = [
  PluginEvent.APPOINTMENT_CANCELLED,
  PluginEvent.APPOINTMENT_COMPLETED,
  PluginEvent.APPOINTMENT_CREATED,
  PluginEvent.INVITE_ACCEPTED,
  PluginEvent.APPOINTMENT_EDITED
];
function isAppointmentEvent(message) {
  return APPOINTMENT_EVENTS.includes(message.type);
}
var INVALID_ENTITY_EVENTS = [
  PluginMisconfigured.EMPLOYEE_ID,
  PluginMisconfigured.INTENT_WITHOUT_RESOURCE_CODE,
  PluginMisconfigured.INVALID_FLOW,
  PluginMisconfigured.INVALID_INTENT,
  PluginMisconfigured.INVALID_RESOURCE_CODE,
  PluginMisconfigured.MEETING_TYPE,
  PluginMisconfigured.OFFICE_ID,
  PluginMisconfigured.SUBJECT_ID
];
function isInvalidEntityEvent(message) {
  return INVALID_ENTITY_EVENTS.includes(message.type);
}
function queueMacroTask(fn) {
  setTimeout(fn);
}
function warnPrivate({ name, type }) {
  logger.warn(
    `The ${type} "${name}" is intended for debugging purposes only and might be changed at any time without notice. Its use in production is strongly discouraged and not supported`
  );
}

// src/index.ts
var PluginStatic = new Proxy(PluginInstance, {
  apply(Instance, _, argumentsList) {
    return new Instance(argumentsList[0], argumentsList[1]);
  }
});
function installGlobals() {
  if (!window.Skedify?.Plugin) {
    window.Skedify = {
      ...window.Skedify,
      translationSource() {
        console.warn("translationSource is no longer supported.");
      },
      Plugin: PluginStatic
    };
  }
  if (!window.SkedifyPlugin) {
    window.SkedifyPlugin = PluginStatic;
  }
  if (!window.PexipEngage?.Plugin) {
    window.PexipEngage = { ...window.PexipEngage, Plugin: PluginStatic };
    dispatchEvent({
      target: document,
      type: PluginStatic.EVENT_INIT,
      bubbles: true,
      cancelable: true
    });
  }
}
export {
  PEXIP_ENGAGE_PLUGIN_EVENT,
  PluginStatic,
  installGlobals
};
